import React, { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as BillIcon } from "../../assets/svg/bill.svg";
import { ReactComponent as HomeIcon } from "../../assets/svg/home.svg";
import { ReactComponent as MoneyIcon } from "../../assets/svg/money.svg";
import { ReactComponent as UserIcon } from "../../assets/svg/user.svg";
import { TabBar, TabBarItem } from "../../components/weui";
import { urls } from "../../urls";


export const MainTabBar = props => {
  const navigate = useNavigate();
  const location = useLocation();

  const goto = useCallback(to => {
    navigate(to);
  }, [navigate]);

  const isActive = useCallback((ln, exact = false) => {
    return exact 
      ? location.pathname === ln
      : location.pathname.startsWith(ln);
  }, [location]);

  const homeUrl = urls.home();
  const feeUrl = urls.fee();
  const billUrl = urls.bill();
  const meUrl = urls.me();

  return (
    <TabBar>
      <TabBarItem label="首页" active={ isActive(homeUrl, true) } onClick={ e => goto(homeUrl) } icon={ HomeIcon } />
      <TabBarItem label="充值" active={ isActive(feeUrl) } onClick={ e => goto(feeUrl) } icon={ MoneyIcon } />
      <TabBarItem label="账单" active={ isActive(billUrl) } onClick={ e => goto(billUrl) } icon={ BillIcon } />
      <TabBarItem label="我的" active={ isActive(meUrl) } onClick={ e => goto(meUrl) } icon={ UserIcon } />
    </TabBar>
  );
};
